import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface FeatureFlags {
  data_pane_v2: boolean;
}

interface FeatureFlagsState extends FeatureFlags {
  setFlag: <K extends keyof FeatureFlags>(key: K, value: FeatureFlags[K]) => void;
  reset: () => void;
}

const DEFAULTS: FeatureFlags = {
  data_pane_v2: true,
};

export const useFeatureFlagsStore = create<FeatureFlagsState>()(
  persist(
    (set) => ({
      ...DEFAULTS,
      setFlag: (key, value) => set({ [key]: value } as Partial<FeatureFlags>),
      reset: () => set(DEFAULTS),
    }),
    { name: 'zoneium-feature-flags' },
  ),
);

export const useFeatureFlag = <K extends keyof FeatureFlags>(key: K): FeatureFlags[K] =>
  useFeatureFlagsStore((s) => s[key]);
